var map = {
	"./decidim/avatar-multiuser.png": 89491,
	"./decidim/brands/google.svg": 13138,
	"./decidim/cc-badge.png": 22129,
	"./decidim/decidim-logo.svg": 3585,
	"./decidim/default-avatar.svg": 14081,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 27447,
	"./decidim/icons.svg": 82144,
	"./decidim/pattern.png": 4899,
	"./decidim/placeholder-card-g.svg": 15744,
	"./decidim/placeholder-card-l.svg": 13131,
	"./decidim/placeholder.jpg": 54466,
	"./decidim/remixicon.symbol.svg": 17272,
	"./decidim/vendor/leaflet/layers-2x.png": 65809,
	"./decidim/vendor/leaflet/layers.png": 19640,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 67785,
	"./decidim/vendor/leaflet/marker-icon.png": 18240,
	"./decidim/vendor/leaflet/marker-shadow.png": 48959,
	"./decidim/vendor/social-share-button/douban.svg": 92331,
	"./decidim/vendor/social-share-button/email.svg": 48548,
	"./decidim/vendor/social-share-button/facebook.svg": 65536,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 22036,
	"./decidim/vendor/social-share-button/hacker_news.svg": 81608,
	"./decidim/vendor/social-share-button/linkedin.svg": 27490,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 89675,
	"./decidim/vendor/social-share-button/pinterest.svg": 49986,
	"./decidim/vendor/social-share-button/reddit.svg": 79064,
	"./decidim/vendor/social-share-button/telegram.svg": 91245,
	"./decidim/vendor/social-share-button/tumblr.svg": 16330,
	"./decidim/vendor/social-share-button/twitter.svg": 84481,
	"./decidim/vendor/social-share-button/vkontakte.svg": 25387,
	"./decidim/vendor/social-share-button/wechat.svg": 25078,
	"./decidim/vendor/social-share-button/whatsapp.svg": 48814,
	"./decidim/vendor/social-share-button/x.svg": 96220,
	"./decidim/vendor/social-share-button/xing.svg": 9500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15378;